<app-report-table [reportTableService]="reportService"></app-report-table>
